import { omitKeys } from 'lib/object/objectUtils'

export function slimifyGeo(geo: App.GeoState): Omit<App.GeoState, 'originAirports' | 'airports' | 'initialised'> {
  return omitKeys(['originAirports', 'airports', 'initialised'], geo)
}

export function getPlaceKey(latitude?: number, longitude?: number, levels?: Array<App.PlaceType>): string {
  if (!latitude || !longitude) {
    return 'no-lat-long'
  }

  if (!levels) {
    return `${latitude}-${longitude}`
  }

  return `${latitude}-${longitude}-${levels?.join(',')}`
}
